import React from 'react';
import { Form as FinalForm } from 'react-final-form';
import { Form } from '../../components';
import FieldTextEditor from './FieldTextEditor';

const FormComponent = props => (
  <FinalForm
    {...props}
    onSubmit={() => null}
    render={({ handleSubmit }) => (
      <Form onSubmit={handleSubmit}>
        <FieldTextEditor
          id="exampleBio"
          name="exampleBio"
          type="textarea"
          placeholder="Write something..."
          isBio
        />
      </Form>
    )}
  />
);

export const Bio = {
  component: FormComponent,
  props: {},
  group: 'inputs',
};

const PortfolioWorkFormComponent = props => (
  <FinalForm
    {...props}
    onSubmit={() => null}
    render={({ handleSubmit }) => (
      <Form onSubmit={handleSubmit}>
        <FieldTextEditor
          id="examplePortfolioWork"
          name="examplePortfolioWork"
          type="textarea"
          placeholder="Write something..."
          isPortfolioWork
        />
      </Form>
    )}
  />
);

export const PortfolioWork = {
  component: PortfolioWorkFormComponent,
  props: {},
  group: 'inputs',
};

const CompactWithCounterComponent = props => (
  <FinalForm
    {...props}
    onSubmit={() => null}
    render={({ handleSubmit }) => (
      <Form onSubmit={handleSubmit}>
        <FieldTextEditor
          id="exampleCompact"
          label="Description"
          name="exampleCompact"
          type="textarea"
          isCompact
          maxLength={500}
          maxLengthMessage="Maximum 500 characters"
        />
      </Form>
    )}
  />
);

export const CompactWithCounter = {
  component: CompactWithCounterComponent,
  props: { initialValues: { exampleCompact: '<p>Hello world</p>' } },
  group: 'inputs',
};
